const NewsDetail = () => import('./Main')

const route = {
  path: '/news/:id',
  name: 'news-detail',
  meta: {
    title: 'News - A D M A N 2 0 1 9'
  },
  component: NewsDetail
}

export default route
